import styled, { css, keyframes } from 'styled-components';

export const ActionsBarWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level2};
  margin-top: ${({ theme }) => theme.spacing.level2};
`;

export const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
  opacity: 0.55;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;

  &:hover {
    opacity: 1;
    background: ${({ theme }) => theme.colors.surfaceContainerHighest};
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`;

export const FeedbackPanel = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  left: 0;
  width: min(320px, calc(100vw - 32px));
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.level3};
  background: ${({ theme }) => theme.colors.surfaceContainer};
  border: 1px solid ${({ theme }) => theme.colors.outlineVariant};
  border-radius: 10px;
  padding: ${({ theme }) => theme.spacing.level3};
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  z-index: 10;
  animation: ${fadeIn} 0.15s ease;
`;

export const FeedbackActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing.level2};
`;

const baseThumb = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.15s ease, color 0.15s ease, opacity 0.15s ease;
`;

export const ThumbButton = styled.button<{ $active?: boolean }>`
  ${baseThumb}
  color: ${({ theme, $active }) => $active ? theme.colors.primary : theme.colors.onSurfaceVariant};
  opacity: ${({ $active }) => $active ? 1 : 0.55};

  &:hover {
    opacity: 1;
    background: ${({ theme }) => theme.colors.surfaceContainerHighest};
    color: ${({ theme }) => theme.colors.onSurface};
  }
`;
